import React from "react";
import { useLanguage } from "../context/LanguageContext";

function Footer() {
  const { language } = useLanguage();

  // Helper function to add language prefix to paths
  const getLocalizedPath = (path) => {
    // Split path and query string
    const [pathPart, queryString] = path.split("?");

    if (language === "ar") {
      // Remove /ar if already present to avoid duplication
      const cleanPath = pathPart.startsWith("/ar")
        ? pathPart.replace("/ar", "")
        : pathPart;
      const localizedPath = `/ar${cleanPath === "/" ? "" : cleanPath}`;
      return queryString ? `${localizedPath}?${queryString}` : localizedPath;
    }
    // Remove /ar prefix if present when switching to English
    const englishPath = pathPart.startsWith("/ar")
      ? pathPart.replace("/ar", "") || "/"
      : pathPart;
    return queryString ? `${englishPath}?${queryString}` : englishPath;
  };
  return (
    <div>
      <style>
        {`
          /* Reduce top spacing of footer */
          #footer.footer {
            padding-top: 10px !important;
          }
          
          #footer .footer-wrap .footer-body {
            padding-top: 20px !important;
          }
        `}
      </style>
      {/* Footer */}
      <footer id="footer" className="footer md-pb-70 background-black">
        <div className="footer-wrap wow fadeIn" data-wow-delay="0s">
          <div className="footer-body">
            <div className="container">
              <div className="row">
                <div className="col-xl-2 col-md-4 col-12">
                  <div className="footer-infor">
                    <div className="footer-logo background-black">
                      <a href={getLocalizedPath("/")}>
                        <img
                          src="/assets/images/logo/EL-SALLAB-LOGO-w-colors-2.png"
                          alt=""
                        />
                      </a>
                    </div>
                    <ul>
                      {/* <li>
                        <p className="text-red">
                          Address: 168 Josegh Tito St. Helipolis, <br /> Cairo,
                          Egypt
                        </p>
                      </li> */}
                      <li>
                        <p>
                          {language === "ar" ? "العنوان:" : "Address:"}{" "}
                          <a href="mailto:" className="text-red">
                            168 Josegh Tito St. Helipolis,Cairo, Egypt
                          </a>
                        </p>
                      </li>
                      <li>
                        <p>
                          {language === "ar" ? "البريد الإلكتروني:" : "Email:"}{" "}
                          <a
                            href="mailto:info@azizsallab.com"
                            className="text-red"
                          >
                            info@azizsallab.com
                          </a>
                        </p>
                      </li>
                      <li>
                        <p>
                          {language === "ar" ? "الهاتف:" : "Phone:"}{" "}
                          <a href="tel:(+20) 19601" className="text-red">
                            (+20) 19601
                          </a>
                        </p>
                      </li>
                    </ul>
                    <a
                      href={getLocalizedPath("/contact")}
                      className="tf-btn btn-line"
                    >
                      {language === "ar"
                        ? "احصل على الاتجاهات"
                        : "Get direction"}
                      <i className="icon icon-arrow1-top-left"></i>
                    </a>
                    <ul className="tf-social-icon d-flex gap-10 style-white">
                      <li>
                        <a
                          href="https://www.facebook.com/elsallab/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="box-icon w_34 round social-facebook social-line"
                        >
                          <i className="icon fs-14 icon-fb"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://x.com/abdelazizsallab"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="box-icon w_34 round social-twiter social-line"
                        >
                          <i className="icon fs-12 icon-Icon-x"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/abdelaziz.elsallab/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="box-icon w_34 round social-instagram social-line"
                        >
                          <i className="icon fs-14 icon-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.tiktok.com/@abdelazzizelsallab"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="box-icon w_34 round social-tiktok social-line"
                        >
                          <i className="icon fs-14 icon-tiktok"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youtube.com/@abdelazizelsallab5936"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="box-icon w_34 round social-youtube social-line"
                        >
                          <i className="icon fs-14 icon-youtube"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://wa.me/201020928193"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="box-icon w_34 round social-whatsapp social-line"
                        >
                          <i className="icon fs-14 icon-whatsapp"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xl-2 col-md-4 col-12 footer-col-block">
                  <div className="footer-heading footer-heading-desktop">
                    <h6 className="text-red">
                      {language === "ar" ? "المساعدة" : "Help"}
                    </h6>
                  </div>
                  <div className="footer-heading footer-heading-moblie">
                    <h6 className="text-red">
                      {language === "ar" ? "المساعدة" : "Help"}
                    </h6>
                  </div>
                  <ul className="footer-menu-list tf-collapse-content">
                    <li>
                      <a
                        href="#"
                        className="footer-menu_item"
                        onClick={(e) => e.preventDefault()}
                      >
                        {language === "ar"
                          ? "سياسة الخصوصية"
                          : "Privacy Policy"}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="footer-menu_item"
                        onClick={(e) => e.preventDefault()}
                      >
                        {language === "ar"
                          ? "الإرجاع والاستبدال"
                          : "Returns + Exchanges"}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="footer-menu_item"
                        onClick={(e) => e.preventDefault()}
                      >
                        {language === "ar" ? "الشحن" : "Shipping"}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="footer-menu_item"
                        onClick={(e) => e.preventDefault()}
                      >
                        {language === "ar"
                          ? "الشروط والأحكام"
                          : "Terms & Conditions"}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="footer-menu_item"
                        onClick={(e) => e.preventDefault()}
                      >
                        {language === "ar" ? "الأسئلة الشائعة" : "FAQ's"}
                      </a>
                    </li>
                    {/* <li>
                      <a href="/compare" className="footer-menu_item">
                        Compare
                      </a>
                    </li> */}
                    <li>
                      <a
                        href="#"
                        className="footer-menu_item"
                        onClick={(e) => e.preventDefault()}
                      >
                        {language === "ar" ? "قائمة أمنياتي" : "My Wishlist"}
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-xl-2 col-md-4 col-12 footer-col-block">
                  <div className="footer-heading footer-heading-desktop">
                    <h6 className="text-red">
                      {language === "ar" ? "من نحن" : "About us"}
                    </h6>
                  </div>
                  <div className="footer-heading footer-heading-moblie">
                    <h6 className="text-red">
                      {language === "ar" ? "من نحن" : "About us"}
                    </h6>
                  </div>
                  <ul className="footer-menu-list tf-collapse-content">
                    <li>
                      <a
                        href="#"
                        className="footer-menu_item"
                        onClick={(e) => e.preventDefault()}
                      >
                        {language === "ar" ? "قصتنا" : "Our Story"}
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        className="footer-menu_item"
                        onClick={(e) => e.preventDefault()}
                      >
                        {language === "ar" ? "زيارة متجرنا" : "Visit Our Store"}
                      </a>
                    </li>
                    <li>
                      <a
                        href={getLocalizedPath("/contact")}
                        className="footer-menu_item"
                      >
                        {language === "ar" ? "اتصل بنا" : "Contact Us"}
                      </a>
                    </li>
                    <li>
                      <a
                        href={getLocalizedPath("/account")}
                        className="footer-menu_item"
                      >
                        {language === "ar" ? "الحساب" : "Account"}
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="col-xl-2 col-md-4 col-12 footer-col-block">
                  <div className="footer-heading footer-heading-desktop">
                    <h6 className="text-red">
                      {language === "ar" ? "كيف يعمل؟" : "How it works?"}
                    </h6>
                  </div>
                  <div className="footer-heading footer-heading-moblie">
                    <h6 className="text-red">
                      {language === "ar" ? "كيف يعمل؟" : "How it works?"}
                    </h6>
                  </div>
                  <ul className="footer-menu-list mt-3 tf-collapse-content tf-payment">
                    <li>
                      <img src="/assets/images/payment/img-1.png" alt="" />
                    </li>
                    <li>
                      <img src="/assets/images/payment/img-2.png" alt="" />
                    </li>
                  </ul>
                  <ul className="footer-menu-list mt-3 tf-collapse-content tf-payment">
                    <li>
                      <img src="/assets/images/payment/img-3.png" alt="" />
                    </li>
                    <li>
                      <img src="/assets/images/payment/img-4.png" alt="" />
                    </li>
                  </ul>
                  <ul className="footer-menu-list mt-3 tf-collapse-content tf-payment">
                    <li>
                      <img src="/assets/images/payment/visa.png" alt="" />
                    </li>
                    <li>
                      <img src="/assets/images/payment/paypal.png" alt="" />
                    </li>
                  </ul>
                </div>

                <div className="col-xl-2 col-md-4 col-12">
                  <div className="footer-newsletter footer-col-block">
                    <div className="footer-heading footer-heading-desktop">
                      <h6 className="text-red">
                        {language === "ar" ? "تحتاج مساعدة؟" : "Need Help?"}
                      </h6>
                    </div>
                    <div className="footer-heading footer-heading-moblie">
                      <h6 className="text-red">
                        {language === "ar" ? "تحتاج مساعدة؟" : "Need Help?"}
                      </h6>
                    </div>
                    <div className="tf-collapse-content">
                      <div className="footer-menu_item mb-3">
                        {language === "ar"
                          ? "تواصل معنا فوراً على واتساب للحصول على الدعم والاستفسارات."
                          : "Reach us instantly on WhatsApp for support and inquiries."}
                      </div>
                      <div className="d-grid">
                        <a
                          href="https://wa.me/201020928193"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="tf-btn radius-3 btn-fill btn-icon animate-hover-btn text-red"
                          style={{
                            padding: "14px 20px",
                            fontSize: "16px",
                            textAlign: "center",
                          }}
                        >
                          {language === "ar"
                            ? "تواصل معنا على واتساب"
                            : "WhatsApp Us"}
                          <i
                            className="icon icon-arrow1-top-left"
                            style={{ marginLeft: 8 }}
                          ></i>
                        </a>
                      </div>
                      {/* Language selector removed - using header toggle instead */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="footer-bottom-wrap d-flex gap-20 flex-wrap justify-content-between align-items-center">
                    <div className="footer-menu_item">
                      {language === "ar"
                        ? "© 2026 عبدالعزيز السلاب. جميع الحقوق محفوظة"
                        : "© 2026 Abdelaziz Elsallab. All Rights Reserved"}
                    </div>
                    <div className="tf-payment">
                      <img src="/assets/images/payment/visa.png" alt="" />
                      <img src="/assets/images/payment/img-1.png" alt="" />
                      <img src="/assets/images/payment/img-2.png" alt="" />
                      <img src="/assets/images/payment/img-3.png" alt="" />
                      <img src="/assets/images/payment/img-4.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
